module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms6ae"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHrms6aeIndex,
      "searchBoxAlias": "request-subrogate",
      "addEvent": _vm.addEvent,
      "editEvent": _vm.editEvent,
      "cancelEvent": _vm.cancelEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "detail": _vm.detail,
      "nowLang": _vm.app.nowLang,
      "toggle": _vm.toggle,
      "postHrms6aeSave": _vm.postHrms6aeSave,
      "columnsDetail": _vm.columns[_vm.app.nowLang].detail,
      "columnsDetailPopup": _vm.columns[_vm.app.nowLang].detailPopup,
      "indexSelected": _vm.indexSelected,
      "receivedHrms6aeDetailSearch": _vm.receivedHrms6aeDetailSearch,
      "maxRowspanDetail": _vm.maxRowspan.detail,
      "maxRowspanPopup": _vm.maxRowspan.detailPopup,
      "searchDetail": _vm.searchDetail,
      "saveButtonDisp": _vm.saveButtonDisp,
      "searchIndex": _vm.searchIndex,
      "currentCodempid": _vm.codempid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ecc449e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms6ae/component.vue
// module id = 3557
// module chunks = 1